import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import PageLayout from "../../layouts/PageLayout";
import { ButtonComponent } from "../../components/elements";
import { listTeams } from "../../APIs/TeamRequests";
import TeamsTableComponent from "../../components/tables/TeamsTableComponent";

export default function TeamsListPage() {

    const { t } = useContext(TranslatorContext);
    const [teams, setTeams] = useState([]);
    const [pagination, setPagination] = useState({});
    const [perPage, setPerPage] = useState(10);
    const [searchFilter, setSearchFilter] = useState('');


      useEffect(() => {
        listTeamsFunction();
      }, [perPage, searchFilter]);
    
    const listTeamsFunction = (page=1) => {
        listTeams(page,perPage,searchFilter).then((res) => {
            setTeams(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {

        });
    }

    const redirectToCreatePage = () => {
        window.location.href = '/team-create';
    }

    const thead = [t("name"), t("created"), t("action")];

    const handlePageClick = (selected) => {
        listTeamsFunction(selected.selected + 1);
    }
    
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('teams_list')}</h3>
                           
                            <ButtonComponent  className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent>
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={''}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <TeamsTableComponent
                            thead={ thead }
                            tbody={ teams }
                            refreshPage={ listTeamsFunction }
                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}